import React, {Fragment} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import {setLookPageOpened} from "../../../actions/lookFunctions";
import MaterialSpinner from "../../ui/materialSpinner";
import {setPresetWasChangedByUser} from "../../../actions/actionFunctions";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import WithUpdateLookCartItem from "../hocs/withUpdateLookCartItem";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {applyNewPreset} from "../lookNavigation/lookNavigationFunctions";
import {setWizardActiveStep} from "../../../actions/wizardFunctions";
import {switchToNewVisualizerType} from "../../../misc/visualizerSwitchingFunctions";
import {IS_LIXIL_SERVERS} from "../../../config";

const LookRoomPreset = (props) => {

  const {roomPreset, history, hideOverlay, setLookPageOpened, activePreset, setPresetWasChangedByUser, loadedPresets,
    fabricatorData, initialRoute, setWizardActiveStep, wizardList} = props;

  const isActive = activePreset && (roomPreset.id === activePreset)
    && (!fabricatorData.settings.allowVisualizerSwitching || (roomPreset.visualizerType === document.kvConfig.visualizerType));

  const closeRooms = (afterSwitch = false) => {
    setLookPageOpened(""); // turn button inactive
    hideOverlay(() => {
      if (afterSwitch && fabricatorData.isNhance && initialRoute && initialRoute.includes("look-")) {
        const nextRoute = initialRoute
          .replace(/#\//, "/")
          .replace(/look-\d+\//, "look-"+roomPreset.lookId + "/")
        history.push(nextRoute);
        return
      }
      history.push("/look-"+roomPreset.lookId);
    });
  }

  const roomPresetClick = async (updateLookCartItem) => {
    console.log("roomPreset", roomPreset);
    const analyticsQuery = `id=${roomPreset.id}-lookId=${roomPreset.lookId}-layout_type=${roomPreset.layout_type}-scene=${roomPreset.scene}`;
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookRoomIdeasPreset + analyticsQuery);

    if (isActive) {
      closeRooms();
      return false
    }
    setPresetWasChangedByUser(roomPreset.id);
    loaderEnable();
    if (roomPreset.visualizerType !== document.kvConfig.visualizerType) {
      await switchToNewVisualizerType(roomPreset.visualizerType, true)
    }
    await applyNewPreset(roomPreset, loadedPresets);
    updateLookCartItem();
    loaderDisable();
    closeRooms(true);

    if (fabricatorData.isEncore) {
      wizardList.forEach(wizardItem => {
        setWizardActiveStep(0, wizardItem, null, true); // force erase values on room change
      })
    }

  }

  return (
    <li className={"ll-layout ll-room" + (isActive ? " ll-room--active" : "")}
        style={{backgroundImage: `url(${roomPreset.bv_screen})`}}>
      {roomPreset && roomPreset.bv_screen ? (
        <Fragment>
          {IS_LIXIL_SERVERS ? ( // removed title for all fabricators https://qcquotecountertops.atlassian.net/browse/LX-629
            <div className="ll-room__desc">
              <span className="ll-room__desc-title">Style: {roomPreset.presetTitle || "-"}</span>
              <span className="ll-room__desc-price">Price: ${roomPreset.presetPrice || 0}</span>
            </div>
          ) : null}
          <WithUpdateLookCartItem>
            {(updateLookCartItem) => (
              <Button className={"look-button look-button--primary look-button--min ll-room__button"}
                      endIcon={<ChevronRightIcon />}
                      onClick={() => roomPresetClick(updateLookCartItem)}>
                <FormattedMessage id="buttons.customize"/>
              </Button>
            )}
          </WithUpdateLookCartItem>
        </Fragment>
      ) : <MaterialSpinner/>}
    </li>
  )
};

LookRoomPreset.propTypes = {
  roomPreset: PropTypes.object,
  hideOverlay: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {activePreset, loadedPresets} = store.bathroomVisualizerState;
  const {initialRoute} = store.serverState;
  const {wizardList} = store.wizardState;
  const fabricatorData = store.fabricatorState;
  return {
    activePreset,
    loadedPresets,
    fabricatorData,
    initialRoute,
    wizardList
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setPresetWasChangedByUser,
  setWizardActiveStep,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookRoomPreset)
)

